import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { useProfile } from 'catalog/hooks/use-profile'
import { PriceTag as BasePriceTag } from 'catalog/pages/Product/components/PriceTag'

const formatSeller = seller => {
  if (!seller || typeof seller === 'string') return null

  return {
    brandedInstallments: {
      amount: seller.brandedInstallmentsAmount
    },
    discountPercentage: seller.discountPercentage,
    id: seller.id,
    installments: {
      amount: seller.installmentsAmount,
      value: seller.installmentsValue
    },
    price: {
      from: seller.price.from,
      region: seller.price.regionPrice,
      to: seller.price.to
    }
  }
}

const PriceTag = ({ isBlackWeekend, product, seller }) => {
  const [sellerInfo, setSellerInfo] = useState(seller)
  const selectedSeller = useSelector(({ skus }) => skus.selectedSeller)

  const { isAssistedSale } = useProfile()

  useEffect(() => {
    const currentSeller = formatSeller(selectedSeller) || seller

    setSellerInfo(currentSeller)
  }, [selectedSeller, seller])

  const hasFromPrice = Boolean(sellerInfo.price?.from?.integers)

  return (
    <BasePriceTag
      isAssistedSale={isAssistedSale}
      isBlackWeekend={Boolean(isBlackWeekend)}
      hidePrice={Boolean(product.hidePrice)}
      isSoldOut={Boolean(product.isSoldOut)}
      isPromotional={hasFromPrice}
      toPrice={sellerInfo.price?.to}
      regionPrice={sellerInfo.price?.region}
      fromPrice={sellerInfo.price?.from}
      discount={sellerInfo.discountPercentage}
      unit={product.unit}
      installments={sellerInfo.installments}
      brandedInstallments={sellerInfo.brandedInstallments}
      shopName={selectedSeller?.shop.name}
      hasCrossServices={Boolean(product.hasCrossServices)}
      isServicesEnabled={Boolean(window.env.feature.isServicesEnabled)}
    />
  )
}

PriceTag.propTypes = {
  isBlackWeekend: PropTypes.bool,
  product: PropTypes.shape({
    hidePrice: PropTypes.bool,
    isSoldOut: PropTypes.bool,
    unit: PropTypes.string.isRequired
  }),
  seller: PropTypes.shape({
    brandedInstallments: PropTypes.shape({
      amount: PropTypes.number
    }),
    discountPercentage: PropTypes.number,
    installments: PropTypes.shape({
      amount: PropTypes.number,
      value: PropTypes.string
    }),
    price: PropTypes.shape({
      from: PropTypes.shape({
        decimals: PropTypes.string,
        integers: PropTypes.string
      }),
      region: PropTypes.shape({
        decimals: PropTypes.string,
        integers: PropTypes.string
      }),
      to: PropTypes.shape({
        decimals: PropTypes.string,
        integers: PropTypes.string
      }).isRequired
    })
  })
}

export default PriceTag
